export default "__VITE_ASSET__Bh81vqk8__"